import React from "react";
import CalculMensualiteCredit from "../components/CalculMensualiteCredit";

export default function CalculMensualiteCreditPage() {
  return <CalculMensualiteCredit />;
}
